/**
 * auth.context.ts
 * Secured Communications
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
 */

import * as React from "react";

import { Brand } from "../models/brand";
import { Membership, AccountScopes, PermissionLevel } from "../models/auth";

export interface AuthContext {
  //account?: Account,
  readonly domain: string,
  readonly brand: Brand,
  readonly membership: Membership | null,
  readonly memberships: Array<Membership>,
  readonly access_token: string,
  tz(): string,
  finishedLogin(): Promise<void>,
  setAccount(membership: Membership | null): Promise<void>,
  can(level: PermissionLevel, perm: keyof AccountScopes): boolean
}

/* eslint-disable @typescript-eslint/no-unused-vars */
export const AuthContext: React.Context<AuthContext> = React.createContext({
  domain: "",
  brand: Brand.WORKSPACE,
  access_token: "",
  membership: null,
  memberships: [],
  tz: (): string => "",
  finishedLogin: async (): Promise<void> => {},
  setAccount: async (): Promise<void> => {},
  can: (_level: PermissionLevel, _perm: keyof AccountScopes): boolean => { return false; }
} as AuthContext);
/* eslint-enable @typescript-eslint/no-unused-vars */